<template>
  <section class="hero">
    <Swiper :slides-per-view="1" :space-between="50">
      <SwiperSlide v-for="item in bannerList" :key="item.id">
        <div class="slide">
          <div class="media-wrap">
            <img v-if="item.imageUrl" class="media" :src="item.imageUrl" />
            <video v-if="item.videoUrl" class="media" :src="item.videoUrl" autoPlay loop muted
              @loadeddata="videoLoadEnd" controlslist="nodownload" playsinline webkit-playsinline preload="metadata" />
            <!-- 桌面端标题叠加在图片上 -->
            <div class="content content--overlay">
              <div class="title">{{ item.title }}</div>
              <div class="subTitle">{{ item.description }}</div>
            </div>
          </div>
          <!-- 移动端标题在图片下方 -->
          <div class="content content--below" v-if="item.title || item.description">
            <div class="title" v-if="item.title">{{ item.title }}</div>
            <div class="subTitle" v-if="item.description">{{ item.description }}</div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script setup lang="ts">
import { Banner, queryPageBanner } from '@/api/page_config'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

const bannerList = ref<Banner[]>([])

const videoLoadEnd = (e: Event) => {
  const video = e.target as HTMLVideoElement
  video.play()
}

onMounted(async () => {
  const { path } = useRoute()
  const res = await queryPageBanner(path)
  bannerList.value = res.data.result.bannerList.sort((a, b) => a.sortNum - b.sortNum) || []
})
</script>
<style scoped lang="scss">
@use '@/assets/styles/variables' as *;

.slide {
  width: 100%;
  overflow: hidden;
  background: $color-bg;
}

.media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;

  @media (min-width: $breakpoint-md) {
    aspect-ratio: 3.2;
  }
}

.media {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

video.media {
  object-fit: contain;
}

/* 移动端：标题在图片下方白色背景 */
.content--below {
  display: block;
  padding: 1.25rem 1rem 1.5rem;
  background: $color-bg;
  text-align: left;

  .title {
    color: $color-text;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 0.25rem;
  }

  .subTitle {
    font-size: 1.5rem;
    font-weight: 800;
    line-height: 1.3;
    color: $color-text;
    letter-spacing: -0.01em;
  }

  @media (min-width: $breakpoint-md) {
    display: none;
  }
}

/* 桌面端：标题叠加在图片上 */
.content--overlay {
  display: none;

  @media (min-width: $breakpoint-md) {
    display: block;
    position: absolute;
    left: 2rem;
    bottom: 2rem;

    .title {
      color: #ffffff;
      text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
      font-size: 1rem;
      text-align: left;
    }

    .subTitle {
      font-size: 2rem;
      text-align: left;
      font-variation-settings: 'opsz' auto;
      color: #ffffff;
      text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
